import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';

import keycloakService from '../keycloak_service';

import { getHostname } from './url_utils';
import { sinatraOrigin } from '../config';

export const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then((response) => {
  if (!response.ok){
    throw new Error(response?.statusText || 'Unexpected Server Error');
  }
  return response.json();
})

const sendAll = (emails, sender) => {
  const uniqEmails = emails?.length ? uniq(emails) : [];
  return Promise.all(uniqEmails.map(sender))
}

export const sendEmailInvitation = (email) => {
  const body = JSON.stringify({ email });

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v1/api/users/invite', fetchOptions)
}

export const sendWorkspaceInvitation = (user, workspaceId) => {
  const body = JSON.stringify({
    email: user.email,
    user_id: user.id,
    workspace_id: workspaceId || undefined,
    url: `${getHostname()}/workspaces/${workspaceId}`,
    // By default, nullish userTypes are Collaborators in rest-api.
    user_type: user.role
  })

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v1/api/workspaces/add_user', fetchOptions)
}

// For inviting users to Wallaroo Product
export const sendEmailInvitations = (emails = [], sendWith = sendEmailInvitation) => sendAll(emails, sendWith)

// For inviting users to Workspaces
export const sendWorkspaceInvitations = async (workspaceId, users = []) => {
  const uniqUsers = users?.length ? uniqBy(users, user => user.id) : [];
  const promises = uniqUsers.map(user => sendWorkspaceInvitation(user, workspaceId));

  return Promise.all(promises)
}

export default sendEmailInvitations;
